module.exports = __webpack_public_path__ + "static/Motor_Equations-4dfb96c982779d27c75a031d2155d412.png";